// import { LBL_EVENT } from "./labelConfigs";
// IN labelConfigs THE FUNCTION userGroupUrlCheck CALLED AT THE TOP OF THE FILE, WHICH USES VALUES OF THIS FILE, SO THE IMPORT OF 'LBL_EVENT' FROM labelConfigs CAUSES ERROR. THATS WHY ITS DECLARED HERE AS VARIABLE 
let LBL_EVENT = 'Project'; 

export const GOOGLE_API_KEY = '';

export const DEFAULT_TIME_ZONE      = 'Europe/London'; 
export const DEFAULT_COUNTRY_NAME   = 'British'; 
export const DEFAULT_COUNTRY_CODE   = 'GB';  
export const DEFAULT_GENDER         = 'Male';  

export const LOGIN_SUPER_ADMIN_GROUP    = '1';
export const LOGIN_AFFILIATE_GROUP      = '2';
export const LOGIN_OMNU_AFFILIATE_GROUP = '3'; 
export const LOGIN_CLIENT_GROUP         = '4';
export const LOGIN_CREW_GROUP           = '5';

export const DISABLE_LOC_DET_EDIT = false; // MAKE true AFTER IMPLEMENTING GOOGLE MAP TO PICK LOCATION 

export const PHONE_ISD_CODE = 'gb';
export const PHONE_ISD_NUM  = '+44'; 

// ENUM_EVENT STATUS IS USED TO IMPROVE CODE READABILITY. 
// FOR e.g. THE COMPLETED STATUS CODE OF EVENT_STATUS CAN BE ACCESSED BY 
// EVENT_STATUS[ENUM_EVENT_STATUS.COMPLETED].statusCode
// SO THE NUMBERS GIVEN TO THE KEYS OF ENUM_EVENT_STATUS ARRAY ARE INDEX NUMBERS OF OBJECT ARRAY 'EVENT_STATUS' 
export const ENUM_EVENT_STATUS = { 
    ESTIMATION : 0,
    QUOTE_REQUESTED : 1,
    QUOTE_SENT : 2,
    CONFIRMED: 3,
    DECLINED : 4,
    ON_GOING : 5,
    COMPLETED : 6,
    CANCELLED : 7,
    REESTIMATION : 8,
    INVOICED : 9
};  // STARTS FROM 0 TO USE AS ARRAY KEY SCHEDULED : 8,
export const EVENT_STATUS = [ 
    {statusCode:'1',  statusString:'Estimation', clientStatusString:'Estimation', colorClass:'estimation'},
    {statusCode:'2',  statusString:'Quote Requested', clientStatusString:'Quote Requested', colorClass:'qrequested'},
    {statusCode:'3',  statusString:'Quote Sent', clientStatusString:'Quote Received', colorClass:'qsent'},
    {statusCode:'4',  statusString:'Confirmed', clientStatusString:'Confirmed', colorClass:'confirmed'},
    {statusCode:'5',  statusString:'Quote Declined', clientStatusString:'Quote Declined', colorClass:'qdeclined'},
    {statusCode:'6',  statusString:'On Going', clientStatusString:'On Going', colorClass:'ongoing'},
    {statusCode:'7',  statusString:'Completed', clientStatusString:'Completed', colorClass:'completed'},
    {statusCode:'8',  statusString:'Cancelled', clientStatusString:'Cancelled', colorClass:'cancelled'},
    {statusCode:'10', statusString:'Reestimation', clientStatusString:'Reestimation', colorClass:'reestimation'},
    {statusCode:'11', statusString:'Invoiced', clientStatusString:'Invoiced', colorClass:'completed'} 
]; // {statusCode:'9',  statusString:'Scheduled', clientStatusString:'Scheduled', colorClass:'mango-tango'},
export const EVENT_STATUS_ESTIMATION        = 1; 
export const EVENT_STATUS_QUOTE_REQUESTED   = 2; 
export const EVENT_STATUS_QUOTE_SENT        = 3; 
export const EVENT_STATUS_QUOTE_DECLINED    = 5; 
export const EVENT_STATUS_ONGOING           = 6;  
export const EVENT_STATUS_COMPLETED         = 7;  
export const EVENT_STATUS_CANCELLED         = 8;  
export const EVENT_STATUS_REESTIMATION      = 10;  
export const EVENT_STATUS_INVOICED          = 11;


export const ENUM_QUOTE_STATUS = {
    ESTIMATION : 0,
    QUOTE_REQUESTED : 1,
    QUOTE_SENT : 2,
    ACCEPT_QUOTE: 3,
    DECLINE_QUOTE : 4,
    REESTIMATION : 5,
    CANCELLED : 6
}; // STARTS FROM 0  TO USE AS ARRAY KEY 
export const QUOTE_STATUS = [
    {statusCode:'1', statusString:'Estimation', clientStatusString:'Estimation', colorClass:'estimation'},
    {statusCode:'2', statusString:'Quote Requested', clientStatusString:'Quote Requested', colorClass:'qrequested'},
    {statusCode:'3', statusString:'Quote Sent', clientStatusString:'Quote Received', colorClass:'qsent'},
    {statusCode:'4', statusString:'Quote Accepted', clientStatusString:'Quote Accepted', colorClass:'confirmed'},
    {statusCode:'5', statusString:'Quote Declined', clientStatusString:'Quote Declined', colorClass:'qdeclined'},
    {statusCode:'6', statusString:'Reestimation', clientStatusString:'Reestimation', colorClass:'reestimation'}, 
    {statusCode:'7', statusString:'Cancelled', clientStatusString:'Cancelled', colorClass:'cancelled'}, 
];

export const QUOTE_STATUS_ESTIMATION    = 1; 
export const QUOTE_STATUS_REQUESTED     = 2; 
export const QUOTE_STATUS_SENT          = 3; 
export const QUOTE_STATUS_ACCEPTED      = 4; 
export const QUOTE_STATUS_DECLINED      = 5; 
export const QUOTE_STATUS_REESTIMATION  = 6; 
export const QUOTE_STATUS_CANCELLED     = 7; 

export const ENUM_SHIFT_STATUS = {
    ESTIMATION : 0,
    QUOTE_REQUESTED : 1,
    QUOTE_SENT : 2,
    CONFIRMED: 3,
    DECLINED : 4,
    ON_GOING : 5,
    COMPLETED : 6,
    CANCELLED : 7,
    REESTIMATION : 8
}; // STARTS FROM 0 TO USE AS ARRAY KEY  // SCHEDULED : 8, (REMOVED ON 06AUG2020 - NOT USING NOW) 

export const SHIFT_STATUS = [
    {statusCode:'1', statusString:'Estimation', clientStatusString:'Estimation', colorClass:'estimation'},
    {statusCode:'2', statusString:'Quote Requested', clientStatusString:'Quote Requested', colorClass:'qrequested'},
    {statusCode:'3', statusString:'Quote Sent', clientStatusString:'Quote Received', colorClass:'qsent'},
    {statusCode:'4', statusString:'Confirmed', clientStatusString:'Confirmed', colorClass:'confirmed'},
    {statusCode:'5', statusString:'Quote Declined', clientStatusString:'Quote Declined', colorClass:'qdeclined'},
    {statusCode:'6', statusString:'On Going', clientStatusString:'On Going', colorClass:'ongoing'},
    {statusCode:'7', statusString:'Completed', clientStatusString:'Completed', colorClass:'completed'},
    {statusCode:'8', statusString:'Cancelled', clientStatusString:'Cancelled', colorClass:'cancelled'},
    {statusCode:'10',statusString:'Reestimation', clientStatusString:'Reestimation', colorClass:'reestimation'}, 
]; 
// {statusCode:'9', statusString:'Scheduled', clientStatusString:'Scheduled', colorClass:'mango-tango'}, //(REMOVED ON 06AUG2020 - NOT USING NOW)
export const SHIFT_STATUS_ESTIMATION    = 1;
export const SHIFT_STATUS_ON_GOING      = 6;
export const SHIFT_STATUS_COMPLETED     = 7;  
export const SHIFT_STATUS_CANCELLED     = 8; 
export const SHIFT_STATUS_REESTIMATION  = 10;


export const QUOTE_RECEIVED = 'Quote Received';
export const QUOTE_SENT = '3';


// Schedule User Status- For Crew
export const ENUM_SCHEDULE_CREW_STATUS = { 
    REQUESTED : 1,
    REJECTED : 2,
    ACCEPTED : 3,
    ON_GOING : 4,
    CANCELLED : 5,
    REMOVED_BY_AFFILIATE : 6,
    COMPLETED : 7,
    SHIFT_CANCCELLED : 8,
    ABSENT : 9,
    NOT_CHECKEDIN : 10,
};

export const SCHEDULE_CREW_STATUS = [
    {statusCode:'1', statusString:'Requested', clientStatusString:'Requested', colorClass:'qrequested'},
    {statusCode:'2', statusString:'Rejected', clientStatusString:'Rejected', colorClass:'qdeclined'},
    {statusCode:'3', statusString:'Accepted', clientStatusString:'Accepted', colorClass:'confirmed'},
    {statusCode:'4', statusString:'On Going', clientStatusString:'On Going', colorClass:'ongoing'},
    {statusCode:'5', statusString:'Cancelled', clientStatusString:'Cancelled', colorClass:'cancelled'},
    {statusCode:'6', statusString:'Removed By Affiliate', clientStatusString:'Removed By Affiliate', colorClass:'qdeclined'},
    {statusCode:'7', statusString:'Completed', clientStatusString:'Completed', colorClass:'completed'},
    {statusCode:'8', statusString:'Shift Cancelled', clientStatusString:'Shift Cancelled', colorClass:'cancelled'},
    {statusCode:'9', statusString:'Absent', clientStatusString:'Absent', colorClass:'cancelled'},
    {statusCode:'10', statusString:'Not Checked-in', clientStatusString:'Not Checked-in', colorClass:'not_checkedin'}
];

export const ENUM_DOCUMENT_STATUS = {
    NOTVERIFIED : 1,
    VERIFIED : 2,
    REJECTED : 3,
    EXPIRED : 4 
};

export const DOCUMENT_STATUS = [ 
    {statusCode:1, statusString:'Not Verified'},
    {statusCode:2, statusString:'Verified'},
    {statusCode:3, statusString:'Rejected'},
    {statusCode:4, statusString:'Expired'},
]; 

// TRAVEL MODULE ADDED MAY 2025 ON CLIENT REQUEST 
// KEEPING THIS TRAVEL MODULE CALCULATION MASTER FIELDS SAME IN BOTH FRONT END AND BACK END 
// ANY ADD/EDIT/DELETE OF THESE CONSTANTS MUST DONE IN BOTH FRONT END AND BACK END TOGETHER
export const TM_FIELD_DISTANCE_ID    = 1;
export const TM_FIELD_TIME_ID        = 2;
export const TM_FIELD_PSNGR_COUNT_ID = 3;
export const TM_FIELD_FLAT_AMOUNT_ID = 4;

// IN labelConfigs THE FUNCTION userGroupUrlCheck CALLED AT THE TOP OF THE FILE, WHICH USES VALUES OF THIS FILE, SO THE IMPORT OF 'LBL_...' CONSTANTS FROM labelConfigs CAUSES ERROR. THATS WHY THESE LABELS DECLARED HERE AS VARIABLES
let LBL_TM_FIELD_TYPE_DISTANCE 	    = "Distance in Miles"; // TM - TRAVEL MODULE 
let LBL_TM_FIELD_TYPE_TIME    	    = "Time in Hours";  
let LBL_TM_FIELD_TYPE_PSNGR_COUNT   = "Passenger Count"; 
let LBL_TM_FIELD_TYPE_FLAT_AMOUNT   = "Flat Amount"; 

export const TM_CALULATION_FIELDS = [ 
    {fieldId:TM_FIELD_DISTANCE_ID,    fieldName: LBL_TM_FIELD_TYPE_DISTANCE,    calculationMethod: (LBL_TM_FIELD_TYPE_DISTANCE+' * Num. of Vehicles')},
    {fieldId:TM_FIELD_TIME_ID,        fieldName: LBL_TM_FIELD_TYPE_TIME,       calculationMethod: (LBL_TM_FIELD_TYPE_TIME+' * Num. of Vehicles')},
    {fieldId:TM_FIELD_PSNGR_COUNT_ID, fieldName: LBL_TM_FIELD_TYPE_PSNGR_COUNT, calculationMethod: (LBL_TM_FIELD_TYPE_PSNGR_COUNT+' * Num. of Vehicles')},
    {fieldId:TM_FIELD_FLAT_AMOUNT_ID, fieldName: LBL_TM_FIELD_TYPE_FLAT_AMOUNT, calculationMethod: (' Num. of Vehicles')},
]; 

let sAdminStr    = '/super'; 
let affiliateStr = '/affiliate'; 
let clientStr    = '/client'; 
let crewStr      = '/crew'; 

export const LOGIN_ROUTE_SUPER_ADMIN = sAdminStr;
export const LOGIN_ROUTE_AFFILIATE   = affiliateStr;
export const LOGIN_ROUTE_CLIENT      = clientStr;
export const LOGIN_ROUTE_CREW        = crewStr;

export const LOGIN_ROUTE_NOTFOUND = '/404';
export const ROUTE_PROFILE        = sAdminStr+'/profile'; 
export const ROUTE_REFRESH        = sAdminStr+'/refresh';
export const ROUTE_RESET_PASSWORD = '/reset-password';
export const ROUTE_VERIFY_EMAIL   = '/verify-email';
export const ROUTE_FORGOT_PASSWORD= '/forgot-password';

export const FORGOT_PASSWORD_ROUTE     = sAdminStr+'/forgot-password';
export const FORGOT_PASSWORD_AFFILIATE = affiliateStr+'/forgot-password';
export const FORGOT_PASSWORD_CLIENT    = clientStr+'/forgot-password'; 

export const ROUTE_DASHBOARD      = sAdminStr+'/dashboard'; 
export const ROUTE_QUOTES         = sAdminStr+'/quotes';
export const ROUTE_EVENTS         = sAdminStr+'/events';
export const ROUTE_AFFILIATES     = sAdminStr+'/affiliates';
export const ROUTE_CLIENTS        = sAdminStr+'/clients';
export const ROUTE_CREW           = sAdminStr+'/crew';
export const ROUTE_LOGS           = sAdminStr+'/logs';
export const ROUTE_FEEDBACK       = sAdminStr+'/feedback';
export const ROUTE_ASSOCIATES     = sAdminStr+'/associates';
export const ROUTE_NOTIFICATIONS  = sAdminStr+'/notifications';
export const ROUTE_CLIENT_PROFILE = sAdminStr+'/client-profile';
export const ROUTE_LOGIN_AS       = sAdminStr+'/login-as';
export const ROUTE_BASIC_CONFIG   = sAdminStr+'/basic-config';
export const ROUTE_SA_SETTINGS    = sAdminStr+'/sa-settings';


export const ROUTE_SKILLS                   = sAdminStr+'/skills';
export const ROUTE_SECTORS                  = sAdminStr+'/sectors';
export const ROUTE_SUB_SECTORS              = sAdminStr+'/sub-sectors';
export const ROUTE_OTHER_EXPENSES           = sAdminStr+'/other-expenses';
export const ROUTE_VEHICLE_INFO             = sAdminStr+'/vehicle-info'; 
export const ROUTE_CLIENT_CATEGORY          = sAdminStr+'/client-category'; 
export const ROUTE_CLIENT_DOCS              = sAdminStr+'/client-docs';
export const ROUTE_CREW_DOCS                = sAdminStr+'/crew-docs';
export const ROUTE_DYNAMIC_FIELDS_CREW      = sAdminStr+'/dynamic-fields-crew';
export const ROUTE_DYNAMIC_FIELDS_CLIENTS   = sAdminStr+'/dynamic-fields-clients';
export const ROUTE_DYNAMIC_FIELDS_AFFILIATES= sAdminStr+'/dynamic-fields-affiliates';
export const ROUTE_OMNU_POINTS              = sAdminStr+'/omnu-points';
export const ROUTE_ROLES_PERMISSIONS        = sAdminStr+'/roles-permissions';
export const ROUTE_CHANGE_PASSWORD          = sAdminStr+'/change-password';
export const ROUTE_OMNU_POINTS_SETTINGS     = sAdminStr+'/omnu-point-settings';
export const ROUTE_AFFILIATE_PROFILE        = sAdminStr+'/affiliate-profile';
export const ROUTE_CANCEL_REASONS           = sAdminStr+'/cancel-reasons';
export const ROUTE_TERMS_AND_CONDITIONS     = sAdminStr+'/terms';
export const ROUTE_TERMS_ACCEPT             = sAdminStr+'/terms-accept';
export const ROUTE_TRAVEL_MODULE_FIELDS_AFFILIATES= sAdminStr+'/travel-fields-affiliates';

export const LIST_TYPE      = 'list';
export const ADD_TYPE       = 'add';
export const EDIT_TYPE      = 'edit';
export const UPDATE_TYPE    = 'update';
export const DELETE_TYPE    = 'delete';
export const UPDATE_TYPE_DUO= 'update_duo'; 

export const ROUTE_AFFILIATE_DASHBOARD              = affiliateStr+'/dashboard'; 
export const ROUTE_AFFILIATE_PROFILE_MANAGE         = affiliateStr+'/profile'; 
export const ROUTE_AFFILIATE_SKILLS                 = affiliateStr+'/skills'; 
export const ROUTE_AFFILIATE_XP_PAY_RATE            = affiliateStr+'/appayrate'; 
export const ROUTE_AFFILIATE_CLIENT_DOCS            = affiliateStr+'/client-docs'; 
export const ROUTE_AFFILIATE_CREW_DOCS              = affiliateStr+'/crew-docs'; 
export const ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW    = affiliateStr+'/dynamic-fields-crew';
export const ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS = affiliateStr+'/dynamic-fields-clients';
// export const ROUTE_AFFILIATE_STC_BONUS          = affiliateStr+'/stc-bonus'; // Short Term Call Bonus
export const ROUTE_AFFILIATE_EVENT_LOCATIONS        = affiliateStr+'/event-locations';  
export const ROUTE_AFFILIATE_KEY_LOCATIONS          = affiliateStr+'/key-locations';  
export const ROUTE_AFFILIATE_DEPARTMENTS            = affiliateStr+'/departments';  
export const ROUTE_AFFILIATE_RATECARDS              = affiliateStr+'/rate-cards';  
export const ROUTE_AFFILIATE_OTHER_EXPENSES         = affiliateStr+'/other-expenses';  
export const ROUTE_AFFILIATE_ROLES_PERMISSIONS      = affiliateStr+'/roles-permissions';
export const ROUTE_AFFILIATE_INVITE_FRIEND          = affiliateStr+'/invite-friend';
export const ROUTE_AFFILIATE_CHANGE_PASSWORD        = affiliateStr+'/change-password';
export const ROUTE_AFFILIATE_MASTER_RATE_CARD       = affiliateStr+'/master-rate-cards';
export const ROUTE_AFFILIATE_SKILL_RATE_CARDS       = affiliateStr+'/skill-rate-cards';
export const ROUTE_AFFILIATE_CLIENTS                = affiliateStr+'/clients';
export const ROUTE_AFFILIATE_CREW                   = affiliateStr+'/crew';
export const ROUTE_AFFILIATE_REFRESH                = affiliateStr+'/refresh';
export const ROUTE_AFFILIATE_CLIENT_PROFILE         = affiliateStr+'/client-profile';
export const ROUTE_AFFILIATE_CREW_PROFILE           = affiliateStr+'/crew-profile';
export const ROUTE_AFFILIATE_EVENTS                 = affiliateStr+'/events';
export const ROUTE_AFFILIATE_QUOTES                 = affiliateStr+'/quotes';
export const ROUTE_AFFILIATE_ASSOCIATES             = affiliateStr+'/associates';
export const ROUTE_AFFILIATE_SHIFT                  = affiliateStr+'/shift';
export const ROUTE_AFFILIATE_NOTIFICATIONS          = affiliateStr+'/notifications';
// export const ROUTE_AFFILIATE_SCHEDULE               = affiliateStr+'/schedule';
export const ROUTE_AFFILIATE_SCHEDULE_SHIFT         = affiliateStr+'/schedule-shift';
export const ROUTE_AFFILIATE_TIMESHEET              = affiliateStr+'/timesheet'; 
export const ROUTE_AFFILIATE_TIMESHEET_CREW_BASED   = affiliateStr+'/timesheet-groupby-crew'; 
export const ROUTE_AFFILIATE_LOGS                   = affiliateStr+'/logs';
export const ROUTE_AFFILIATE_SCHEDULE_VIEW          = affiliateStr+'/schedule-view';
export const ROUTE_AFFILIATE_SCHEDULE_SHIFT_CALENDAR= affiliateStr+'/schedule-shift-calendar';
export const ROUTE_AFFILIATE_FEEDBACK               = affiliateStr+'/feedback';
export const ROUTE_AFFILIATE_UNAVILABILITY          = affiliateStr+'/unavailability';
export const ROUTE_AFFILIATE_CSV_TEMPLATES          = affiliateStr+'/csv-templates';
export const ROUTE_AFFILIATE_PAY_LEVELS             = affiliateStr+'/pay-levels'; 
export const ROUTE_AFFILIATE_CERTIFICATES           = affiliateStr+'/certificates'; 
export const ROUTE_AFFILIATE_CLIENT_CATEGORY        = affiliateStr+'/client-category'; 
export const ROUTE_AFFILIATE_VEHICLE_INFO           = affiliateStr+'/vehicle-info'; 
export const ROUTE_AFFILIATE_VEHICLE_DETAILS        = affiliateStr+'/vehicle-details'; 
export const ROUTE_AFFILIATE_CANCEL_REASONS         = affiliateStr+'/cancel-reasons';
export const ROUTE_AFFILIATE_TERMS_ACCEPT           = affiliateStr+'/terms-accept';
export const ROUTE_AFFILIATE_REPORTS                = affiliateStr+'/reports';
export const ROUTE_CREW_AVAILABILITY_REPORTS        = affiliateStr+'/crew-availability-report';
export const ROUTE_CREW_AVAIL_SUMMARY_REPORT        = affiliateStr+'/crew-availability-summary-report';
export const ROUTE_AFFILIATE_BASIC_CONFIG           = affiliateStr+'/basic-config';
export const ROUTE_AFFILIATE_SETTINGS               = affiliateStr+'/settings';

export const ROUTE_CLIENT_PROFILE_MANAGE            = clientStr+'/profile'; 
export const ROUTE_CLIENT_DASHBOARD                 = clientStr+'/dashboard'; 
export const ROUTE_CLIENT_ASSOCIATES                = clientStr+'/associates';
export const ROUTE_CLIENT_QUOTES                    = clientStr+'/quotes'; 
export const ROUTE_CLIENT_EVENTS                    = clientStr+'/events';
export const ROUTE_CLIENT_CHANGE_PASSWORD           = clientStr+'/change-password';
export const ROUTE_CLIENT_REFRESH                   = clientStr+'/refresh';
export const ROUTE_CLIENT_NOTIFICATIONS             = clientStr+'/notifications'; 
export const ROUTE_CLIENT_FEEDBACK                  = clientStr+'/feedback';
export const ROUTE_CLIENT_TIMESHEET                 = clientStr+'/timesheet';
export const ROUTE_CLIENT_TIMESHEET_CREW_BASED      = clientStr+'/timesheet-groupby-crew';
export const ROUTE_CLIENT_LOGS                      = clientStr+'/logs';
export const ROUTE_CLIENT_TERMS_ACCEPT              = clientStr+'/terms-accept';

 
export const TAB1 = 'tab1';
export const TAB2 = 'tab2';
export const TAB3 = 'tab3'; 
export const TAB4 = 'tab4';
export const TAB5 = 'tab5';
export const TAB6 = 'tab6';
export const TAB7 = 'tab7';

export const PAGENUMROWS_SUPER              = 20;  // NUMBER OF ROWS IN PAGINATION
export const PAGENUMROWS_AFFILIATE          = 20;  // NUMBER OF ROWS IN PAGINATION
export const PAGENUMROWS_CLIENT             = 20;  // NUMBER OF ROWS IN PAGINATION 
export const PAGENUMROWS_ACTIVITY_LOG       = 25;
export const PAGENUMROWS_NOTIFICATIONS      = 20;   
export const PAGENUMROWS_SCHEDULE_CREW_VIEW = 20;

export const PAGING_END_INDEX               = 20;
export const PAGING_NOTIFICATIONS           = 25;
export const SCROLL_PAGING_COUNT_AFFILIATE  = 15;

export const SEARCH_TEXT_COUNT      = 3;

export const DYNAMIC_PAGE_ICONS = [ {pageName:'Bank Details', iconName:'las la-university'}, {pageName:'Additional Info', iconName:'las la-ellipsis-h'}, {pageName:'Health Info', iconName:'las la-heartbeat'}, {pageName:'Vehicle Info', iconName:'las la-car-alt'} ]; 

export const DYNAMIC_FIELDS_TYPES   = [ {value:'string', code:'Text'}, {value:'date', code:'Date'}]; // , {value:'file', code:'File'} 

export const DELETE_SYMBOL  = 'las la-2x la-minus-circle text-red spanPointer'; 

export const USER_STATUS = [ {statusCode:'1', statusString:'active'}, {statusCode:'2', statusString:'suspended'}]; 
export const USER_STATUS_PRIMARY = [ {statusCode:'1', statusString:'active'}];

export const CREW_MAX_RATING = [1, 2, 3, 4, 5]; // USED IN crewCardCompoment.js

export const RANDOM_COLORS = ["#ff6e23","#5b2c0d","#90d7f5","#2a7ff6",'#673ed8', "#740f5d",'#f10b15','#be5a26','#7d8286','#e65745','#958c24','#cf9e47'];

export const IMPORT_CREW_CSV_FILE_NAME = "affiliate_crew_list.csv"

export const IMPORT_EVENT_LOCATION_CSV_FILE_NAME = "affiliate_event_locations.csv"

export const IMPORT_CLIENT_CSV_FILE_NAME = "affiliate_client_list.csv"

export const IMPORT_CLIENT_CONTACT_CSV_FILE_NAME = "affiliate_client_contacts.csv"


export const IMPORT_CSV_FILES_ARRAY = [  
    {csvName:(LBL_EVENT+' Locations'), csvType:'event_locations',  csvFileName:IMPORT_EVENT_LOCATION_CSV_FILE_NAME}, 
    {csvName:'Clients',         csvType:'client',           csvFileName:IMPORT_CLIENT_CSV_FILE_NAME},
    {csvName:('Client Contacts '+LBL_EVENT), csvType:'client_contacts',  csvFileName:IMPORT_CLIENT_CONTACT_CSV_FILE_NAME},
    {csvName:'{0} Members',     csvType:'staff_members',    csvFileName:IMPORT_CREW_CSV_FILE_NAME}, 
]; 

export const SHIFT_LENGTH_MAX_HRS = 20; 

// hours: { min: 0, max: 23, step: 1, }
export const ENUM_SHIFT_LENGTH_HHMM = { hours: {max: SHIFT_LENGTH_MAX_HRS}, minutes: {step: 15} }; // TO RESTRICT TIME LENGTH ENTRIES 
export const ENUM_MM15 = { minutes: {step: 15} }; // TO RESTRICT TIME LENGTH ENTRIES 
export const ENUM_MM5  = { minutes: {step: 5} }; // USED IN SHIFT ADD EDIT AND OT IN TIMESHEET EDIT

export const MILES = "Miles"; 
export const KM = "KM"; 

export const QUOTE_VALIDITY_DAYS = 30; 
export const DISTANCE_UNIT = 'Miles'; 

export const AVATAR_BG_COLOR = '#C0C0C0'; 

export const ENUM_CREW_CHECKIN_HHMM = { hours: {max: 23}, minutes: {max: 59, step: 5} }; // TO RESTRICT TIME ENTRIES 
export const ENUM_CREW_OT_HHMM = { hours: {max: 23}, minutes: {max: 59, step: 5} }; // TO RESTRICT TIME ENTRIES 
export const ENUM_CREW_CHECKOUT_HHMM = { hours: {max: 23}, minutes: {max: 59, step: 5} }; // TO RESTRICT TIME ENTRIES 

export const MASTER_RATE_CARD_ROWS = 16;

export const ROLES_PERMISSION_LEFT_ARR = ['quotes','quotessummary','events','acceptquote','schedule', 'timesheet','feedback', 'certificates', 'settings'] 
export const ROLES_PERMISSION_RIGHT_ARR = ['companyprofile','associateusers', 'client',
                                            'crew','crewunavailability', 'assodepartment','logs']
export const ROLES_SETTINGS_PERMISSION_LEFT_ARR = ['eventlocations', 'keylocations', 'settingsdepartments', 'clientcategories',
                                                        'clientdocument', 'crewdocuments', 'dynfieldforclient',
                                                        'dynfieldforcrew', 'vehicleinfo']
export const ROLES_SETTINGS_PERMISSION_RIGHT_ARR = ['skills', 'masterratecard', 'paylevels', 'otherexpenses', 'eventcancelreasons', 
                                                        'rolesandpermissions', 'csvtemplatesdownload', 'inviteafriend']
export const SUPER_ROLES_PERMISSION_LEFT_ARR = ['quotes','quotessummary','events','affiliate','client','timesheet','feedback','settings'] 
export const SUPER_ROLES_PERMISSION_RIGHT_ARR = ['companyprofile','associateusers','logs', 'loginas']
export const SUPER_ROLES_SETTINGS_PERMISSION_LEFT_ARR = ['skills', 'sector', 'subsector', 'otherexpenses', 'clientdocument', 
                                                            'crewdocuments']
export const SUPER_ROLES_SETTINGS_PERMISSION_RIGHT_ARR = ['dynfieldforclient', 'dynfieldforcrew', 
                                                            'dynfieldforaffiliate','performancepoints', 'mnyhandspointsagainstpp', 
                                                            'eventcancelreasons', 'rolesandpermissions', 'termsandconditions']
export const VIEW_ONLY_ARR = ['logs','settings','companyprofile','acceptquote']
export const MODIFY_ONLY_ARR = ['assodepartment']; 

export const UNALLOCATED_SHIFTS_COUNT_DAYS = 30; // USED IN SCHEDULE SHIFT page 

export const TERMS_NOT_ACCEPTED = 'terms_and_conditions_not_accepted';
export const SCROLL_PAGING_CREW_AVAILABILITY_COUNT = 15;

export const FEEDBACK_ACTION_DEFAULT  = 0;
export const FEEDBACK_ACTION_REQUIRED = 1;
export const FEEDBACK_ACTION_TAKEN    = 2;

export const FEEDBACK_DATA_VIEW_TYPE_CLIENT    = 'client';  
export const FEEDBACK_DATA_VIEW_TYPE_CHIEF     = 'chief';  

export const STR_VEHICLE_INFO     = 'Vehicle Info';  

export const SHIFT_STAFF_REQUESTS_PENDING     = 'reqPending';  
export const SHIFT_STAFF_REQUESTS_SENT        = 'reqSent';  
export const SHIFT_STAFF_REQUESTS_ACCEPTED    = 'reqAccepted';  

// SCHEDULE SHIFT REQUEST TO STAFF API RESPONSE CODES 
export const SHIFT_STAFF_REQ_ERR_UNAVAIL            = 'unavailable';
export const SHIFT_STAFF_REQ_ERR_REQUESTED          = 'already_requested';
export const SHIFT_STAFF_REQ_ERR_FILLED             = 'crew_filled';
export const SHIFT_STAFF_REQ_ERR_SKILL_FILLED       = 'crew_skill_filled';
export const SHIFT_STAFF_REQ_ERR_CHEIF_FILLED       = 'chief_filled';
export const SHIFT_STAFF_REQ_ERR_CHEIF_SKILL_FILLED = 'chief_skill_filled';
export const SHIFT_STAFF_REQ_ERR_DEPT_MISMATCH      = 'shift_staff_department_mismatch';

export const DISCOUNT_TYPE_AMOUNT  	    = 'amount'; 
export const DISCOUNT_TYPE_PERCENTAGE   = 'percentage';

// FORGOT PASSWORD RESPONSE 
export const FORGOT_PWD_RESP_INVALID_EMAIL      = 'invalid_email';

// EMAIL SENT TO CLIENT - RESPONSE CODES 
export const CLIENT_EMAILS_MUTED                = 'client_emails_muted';
export const AFFILIATE_ALL_CLIENTS_EMAILS_MUTED = 'affiliate_clients_emails_muted';

export const SHIFT_TIME_CHANGE_ERR_PART_UNAVAILABLE = 'partial_unavailable';
export const SHIFT_TIME_CHANGE_ERR_ALL_UNAVAILABLE  = 'all_unavailable'; 

export const SHIFT_CANCEL_SUCCESS_CODE  = 'shift_cancelled_successfully'; 
export const SHIFT_CANCEL_ERROR_CODE    = 'shift_cannot_be_cancelled'; 

export const TM_FIELD_ADD_ERROR_CODE    = 'field_name_already_exist'; // TM - TRAVEL MODULE

